<template>
  <div>
    <div class="card card-custom gutter-b example example-compact">
      <div class="card-header">
        <div class="card-title">
          <router-link to="/admin/customers" class="mr-5">
            <b-icon icon="arrow-left" scale="1.5"></b-icon>
          </router-link>
          <h3>Kunden Details</h3>
        </div>
      </div>
      <div class="card-body">
        <img v-if="details.profile_photo_path" class="mb-5" style="border: 1px solid lightgrey" :src="details.profile_photo_path" width="150px" height="150px" />
        <table class="provider-info-tbl">
          <tr>
            <td>Kundenname:</td>
            <td>{{ details.first_name + " " + details.last_name }}</td>
          </tr>
          <tr>
            <td>E-Mail:</td>
            <td>{{ details.email }}</td>
          </tr>
          <tr>
            <td>Telefonnummer:</td>
            <td>{{ details.mobile_no ? details.mobile_no : "-" }}</td>
          </tr>
          <tr>
            <td>Geburtsdatum:</td>
            <td>{{ details.customer_detail && details.customer_detail.dob ? formatDate(details.customer_detail.dob) : "-" }}</td>
          </tr>
          <tr>
            <td>Adresse:</td>
            <td>{{ details.customer_detail && details.customer_detail.address ?details.customer_detail.address : "-" }}</td>
          </tr>
          <tr>
            <td>UID:</td>
            <td>{{ details.customer_detail && details.customer_detail.uid ? details.customer_detail.uid : "-" }}</td>
          </tr>
          <tr>
            <td>Firmenname:</td>
            <td>{{ details.customer_detail && details.customer_detail.company_name ? details.customer_detail.company_name : "-" }}</td>
          </tr>
          <tr>
            <td>Postleitzahl:</td>
            <td>{{ details.customer_detail && details.customer_detail.postcode ? details.customer_detail.postcode : "-" }}</td>
          </tr>
          <tr>
            <td>Stadt:</td>
            <td>{{ details.customer_detail && details.customer_detail.city ? details.customer_detail.city : "-" }}</td>
          </tr>
          <tr>
            <td>Land:</td>
            <td>{{ details.customer_detail && details.customer_detail.country ? details.customer_detail.country : "-" }}</td>
          </tr>
        </table>
        <!-- <div class="table-responsive mt-5">
          <v-simple-table class="record-table">
            <thead>
              <tr>
                <th class="text-center align-middle" width="8%">Sr.No.</th>
                <th
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'product_name',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  Product Name
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'product_name'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'product_name' &&
                        filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'product_name' &&
                        filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <th class="text-center align-middle" width="15%">Unit</th>
                <th class="text-center align-middle">Status</th>
                <th class="text-center align-middle" width="10%">Actions</th>
              </tr>
            </thead>
            <tr>
              <td></td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchNameKey"
                    solo
                    label="Search name..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td>
                <div class="search-input-div">
                  <v-select
                  :items="unitsList"
                  v-model="searchUnitKey"
                  item-text="unit"
                  item-value="id"
                  label="Search Unit..."
                  solo
                  clearable
                />
                </div>
              </td>
              <td>
                <v-select
                  :items="statusItems"
                  v-model="searchStatusKey"
                  item-text="title"
                  item-value="value"
                  label="Search status..."
                  solo
                  clearable
                />
              </td>
              <td></td>
            </tr>
            <tbody v-if="details.length">
              <tr v-for="(product, i) in details" :key="product.id">
                <td class="align-middle">
                  {{ i + 1 }}
                </td>
                <td class="align-middle">
                  {{ product.product_name.length > 30 ? product.product_name.substr(0, 30) + "..." : product.product_name }}
                </td>
                <td class="align-middle">
                  {{ product.unit_detail.unit ? product.unit_detail.unit : "-" }}
                </td>
                <td class="align-middle">
                  {{
                    product.is_status == 1
                      ? "Confirmation Pending"
                      : product.is_status == 0
                      ? "Draft"
                      : product.is_status == 2
                      ? "Online"
                      : "Offline"
                  }}
                </td>
                <td class="align-middle text-center icon-wrapper-block">
                  <a v-if="product.is_status == 2"  @click="changeStatus(product.id, product.is_status)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="eye"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Online</span>
                    </v-tooltip>
                  </a>
                  <a v-if="product.is_status == 3">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="eye-slash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Offline</span>
                    </v-tooltip>
                  </a>
                  <a
                    v-if="product.is_status == 1"
                    @click="changeStatus(product.id, product.is_status)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">                       
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="hourglass"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Confirmation Pending</span>
                    </v-tooltip>
                  </a>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="loading_details" class="loading-tbody">
              <td colspan="10">
                Loading...
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </td>
            </tbody>
            <tbody v-else class="loading-tbody">
              <tr>
                <td colspan="10">No Records Found</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="d-flex pagination-block">
            <b-pagination
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total-rows="pagination.paginationRows"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="paginationChange"
            >
              <template #prev-text
                ><span
                  ><b-icon
                    icon="chevron-left"
                    aria-hidden="true"
                  ></b-icon></span
              ></template>
              <template #next-text
                ><span
                  ><b-icon
                    icon="chevron-right"
                    aria-hidden="true"
                  ></b-icon></span
              ></template>
            </b-pagination>
          </div>
        </div> -->
      </div>
    </div>
    <b-modal
      v-model="showFileModal"
      class="file-modal"
      centered
      hide-footer
      resizable
    >
      <div v-if="modalFile">
        <div>
          <b-img :src="modalFile" class="modal-image"></b-img>
        </div>
      </div>
    </b-modal>
    <v-dialog v-model="statusDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Please Confirm
        </v-card-title>

        <v-card-text>
          <span>Are you sure to change the status of this product?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            No
          </v-btn>
          <v-btn
            type="submit"
            @click="changeStatusRecord(statusRecordId, newStatus)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Please Confirm
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Eintrag wirklich löschen?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            No
          </v-btn>
          <v-btn
            type="submit"
            @click="deleteRecord(deleteRecordId)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notifications group="producres" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import HtmlClass from "@/core/services/htmlclass.service";
//import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Notifications from "vue-notification";
//import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";

Vue.use(Notifications);

export default {
  name: "Producerdetails",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.producerId = this.$route.params.id;
      const customerPromise = this.getCustomerDetails();
      Promise.all([customerPromise]);
    }
  },
  data() {
    return {
      loading_details: true,
      filter: {
        orderCol: "id",
        orderBy: "desc",
      },
      searchNameKey: "",
      //searchAddressKey: "",
      //searchPriceKey: "",
      searchStatusKey: "",
      searchUnitKey: "",
      producerId: "",
      userId: null,
      showFileModal: false,
      modalFile: null,
      details: [],
      statusItems: [
        {
          title: "Draft",
          value: "0",
        },
        {
          title: "Confirmation Pending",
          value: "1",
        },
        {
          title: "Online",
          value: "2",
        },
        {
          title: "Offline",
          value: "3",
        },
      ],
      unitsList: [],
      deleteRecordId: null,
      statusDialog: false,
      deleteDialog: false,
      statusRecordId: null,
      yesActionLoading: false,
      disabledCancel: false,
      newStatus: null,
      pagination: {
        currentPage: 1,
        perPage: 20,
        paginationRows: "",
      },
    };
  },
  components: {
    // 'money-format': MoneyFormat
  },
  watch: {
    searchNameKey: {
      handler: function (val, oldVal) {
        this.details = [];
        this.loading_details = true;
        this.getCustomerDetails();
      },
      deep: true,
    },
    /*searchAddressKey: {
      handler: function (val, oldVal) {
        this.properties = [];
        this.loading_details = true;
        this.getCustomerDetails();
      },
      deep: true,
    },*/
    /*searchPriceKey: {
      handler: function (val, oldVal) {
        this.details = [];
        this.loading_details = true;
        this.getCustomerDetails();
      },
      deep: true,
    },*/
    searchStatusKey: {
      handler: function (val, oldVal) {
        this.details = [];
        this.loading_details = true;
        this.getCustomerDetails();
      },
      deep: true,
    },
    searchUnitKey: {
      handler: function (val, oldVal) {
        this.details = [];
        this.loading_details = true;
        this.getCustomerDetails();
      },
      deep: true,
    },
  },
  methods: {
    hideModal() {
      this.statusDialog = false;
      this.yesActionLoading = false;
      this.deleteDialog = false;
    },
    clearInput(type) {
      switch (type) {
        case "name":
          this.searchNameKey = "";
          break;

        /*case "address":
          this.searchAddressKey = "";
          break;*/

        /*case "price":
          this.searchPriceKey = "";
          break;*/
      }
    },
    sortListing(orderCol, orderBy) {
      if (!this.loading_details) {
        this.details = [];
        this.filter.orderCol = orderCol;
        this.filter.orderBy = orderBy;
        this.pagination.currentPage = 1;
        this.loading_details = true;
        this.getCustomerDetails();
      }
    },
    openFileModal(file) {
      this.showFileModal = true;
      this.modalFile = file;
    },
    // paginationChange() {
    //   this.details = [];
    //   this.loading_details = true;
    //   setTimeout(() => {
    //     this.getCustomerDetails();
    //   }, 100);
    // },
    // getProductUnits() {
    //   adminAPI
    //     .getProductUnits()
    //     .then((response) => {
    //       if (response.status == "success") {
    //         this.unitsList = response.data;
    //       } else {
    //         this.$notify({
    //           group: "details",
    //           type: "error",
    //           position: "bottom right",
    //           text: response.msg,
    //           duration: 3000,
    //         });
    //       }
    //     })
    //     .catch((err) => {
    //       this.$notify({
    //         group: "details",
    //         type: "error",
    //         position: "bottom right",
    //         text: err,
    //         duration: 3000,
    //       });
    //     });
    // },
    getCustomerDetails() {
      adminAPI
        .getCustomerDetails(this.$route.params.id)
        .then((response) => {
          if (response.status == "success") {
            this.details = response.data;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_details = false;
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_details = false;
            this.$notify({
              group: "producres",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.loading_details = false;
          this.$notify({
            group: "producres",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    deleteproperty(id) {
      this.deleteDialog = true;
      this.deleteRecordId = id;
    },
    deleteRecord(id) {
      this.deleteDialog = false;
      this.deleteRecordId = null;
      axios
        .post("delete-property", { id: id })
        .then((response) => {
          var responseJson = response.data;
          if (responseJson.status == "success") {
            this.$notify({
              group: "producres",
              type: "success",
              position: "bottom right",
              text: responseJson.msg,
              duration: 5000,
            });
            this.pagination.currentPage = 1;
            this.getCustomerDetails();
          } else {
            this.$notify({
              group: "producres",
              type: "error",
              position: "bottom right",
              text: responseJson.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producres",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    changeStatus(id, status) {
      if (status == 1) {
        this.newStatus = "2";
      } else if (status == 2) {
        this.newStatus = "3";
      }
      // else if (status == 3) {
      //   this.newStatus = "2";
      // }
      this.statusDialog = true;
      this.statusRecordId = id;
    },
    changeStatusRecord(id, status) {
      this.yesActionLoading = true;
      this.disabledCancel = true;

      adminAPI
        .statusProduct({ id: id, status: status })
        .then((response) => {
          if (response.status == "success") {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "producres",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.getCustomerDetails();
          } else {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "producres",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.statusDialog = false;
          this.statusRecordId = null;
          this.newStatus = null;
          this.yesActionLoading = false;
          this.disabledCancel = false;
          this.$notify({
            group: "producres",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    formatDate(dateString) {
      if (dateString) {
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`;
      }else{
        return '-'
      }
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.invite-btn {
  background-color: #3d5a80;
}

.invite-btn:hover {
  background-color: #002c47;
}

.new-btn-text {
  margin-left: 10px;
  font-size: 13px;
}

a {
  cursor: pointer;
}

.file-modal {
  padding: 0;
  margin: 0;
}

.modal-image {
  width: 100%;
}

.table-image {
  cursor: pointer;
}

th {
  cursor: pointer;
}

.loading-tbody {
  text-align: center;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}
</style>